/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-24 17:08:40
 * @LastEditTime: 2025-01-21 14:54:07
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\enrollMessage\index.tsx
 * @Description: 留言板
 */
import LabelNone from '@/components/label_none';
import { CommmonGet, CommmonPost } from '@/util/network/api';
import { pageSizeList } from '@/util/publicDatas';
import { Form, Input, Select, Spin, message } from 'antd';
import { LgButton, LgPaginationA, LgRadio, LgTextarea } from 'lancoo-web-ui';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserId, selectUserInfo, setLoginShow } from '../../store/reducers/userInfo';
import headerImg from '@/images/userImg/登录、留言板-男学生.png';
import headerImgHide from '@/images/userImg/留言板-匿名头像.png';
import './index.scss';
import ModuleCont from '@/components/moduleCont';
import FileDisplay from '@/components/file_display';
import { downloadFile, previewFile } from '@/util/util';
const { Search } = Input;

const EnrollMessage = () => {

    const service = {
        subMessage: '/portal/messageAndQuestion/subMessage', // 提问
        list: 'portal/messageAndQuestion/getMessages', // 列表
    }
    const dispatch = useDispatch();

    const userId = useSelector(selectUserId);
    const userInfo = useSelector(selectUserInfo);

    const [form] = Form.useForm();

    // 刷新
    const [isloading, setIsloading] = useState<boolean>(true);
    const [onceload, setOnceload] = useState<boolean>(false);
    // 表格
    const [list, setList] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [keyword, setkeyword] = useState<string>('');
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(pageSizeList[0].Info);
    const [typeList, setTypeList] = useState<any[]>([
        { value: 1, label: '全部留言' },
        { value: 2, label: '我的留言' },
    ]);

    const [type, setType] = useState<number>(1);
    const [questionType, setQuestionType] = useState(0)

    const submit = () => {
        if (!userId) {
            dispatch(setLoginShow(true));
            sessionStorage.setItem('tempFormData', JSON.stringify(form.getFieldsValue()));
            return
        }
        const formData = form.getFieldsValue();
        if (formData.msgContent.trim() === '') {
            message.destroy();
            message.warning('提问内容不能为空！');
            return
        }
        setIsloading(true);
        const data = {
            anonymity: formData.anonymity,
            anonymous: 0,
            msgContent: formData.msgContent,
            qType: formData.qType,
            userId,
            userName: userInfo?.username,
        }
        CommmonPost(service.subMessage, data).then(res => {
            message.success('提问成功！')
            // form.resetFields();
            form.setFieldValue("msgContent", '');
            getInit();
        }).catch(err => {
            message.error("提问失败！")
        }).finally(() => {
            setIsloading(false);
        });
    }

    const getInit = (item: any = {}) => {
        setIsloading(true);
        CommmonGet(service.list, {
            pageIndex,
            pageSize,
            keyword,
            type,
            qType: questionType,
            ...item
        }).then((res: any) => {
            setList(res.data?.pageList || []);
            setTotal(res.data.total);
        }).catch(() => {
        }).finally(() => {
            setIsloading(false);
            setOnceload(true);
        });
    };

    function pageSizeSelectA(data: any, index: number) {
        setPageIndex(1);
        setPageSize(data.Info);
    }

    useEffect(() => {
        setTypeList([
            { value: 1, label: '全部留言' },
            ...(userId ? [{ value: 2, label: '我的留言' }] : []),
        ])
    }, [userId])

    useEffect(() => {
        if (sessionStorage.getItem('tempFormData')) {
            form.setFieldsValue(JSON.parse(sessionStorage.getItem('tempFormData') || '{}'));
            sessionStorage.removeItem('tempFormData');
        }
    }, [])

    useEffect(() => {
        getInit();
    }, [pageIndex, pageSize]);

    useEffect(() => {
        setPageIndex(1)
        getInit({ pageIndex: 1 });
    }, [type, questionType]);

    return (
        <div>
            <div className="enrollMessage">
                <div className='quiz'>
                    <Form form={form}>
                        <Form.Item
                            label="提问类型"
                            name={"qType"}
                            initialValue={1}
                            rules={[{ required: false, message: '录取审核时间不能为空!' }]}
                            style={{ marginBottom: 16 }}
                        >
                            <LgRadio.Group>
                                <LgRadio className="g006-form-1-item" value={1}>校园生活</LgRadio>
                                <LgRadio className="g006-form-1-item" value={2}>招生政策</LgRadio>
                                <LgRadio className="g006-form-1-item" value={3}>开学就业</LgRadio>
                                {/* <LgRadio className="g006-form-1-item" value={4}>其他</LgRadio> */}
                            </LgRadio.Group>
                        </Form.Item>
                        <Form.Item
                            label="匿名提问"
                            name={"anonymity"}
                            initialValue={0}
                            rules={[{ required: false, message: '录取审核时间不能为空!' }]}
                            style={{ marginBottom: 16 }}
                        >
                            <LgRadio.Group>
                                <LgRadio className="g006-form-1-item" value={1}>是</LgRadio>
                                <LgRadio className="g006-form-1-item" value={0}>否</LgRadio>
                            </LgRadio.Group>
                        </Form.Item>
                        <div style={{ position: 'relative' }}>
                            <Form.Item
                                label="提问内容"
                                name={"msgContent"}
                                className='quizContent'
                                initialValue={''}
                                rules={[{ required: false, message: '录取审核时间不能为空!' }]}
                                style={{ marginBottom: 0 }}
                            >
                                {/* <LgTextarea
                                    className='textarea-warp'
                                    removeResize={true}
                                    textarea={{
                                        placeholder: "请输入提问内容",
                                        onInput: (e: any) => {
                                            form.setFieldValue("msgContent", e.target.value);
                                        },
                                        maxLength: 500,
                                    }}
                                    style={{ width: "100%", height: 'calc(100% - 32px)' }}
                                /> */}
                                <Input.TextArea
                                    // type={'a'}
                                    autoComplete='off'
                                    showCount
                                    maxLength={500}
                                    placeholder="请输入提问内容"
                                    // style={{ height: "100px", width: "400px", resize: "none", borderRadius: "3px" }}
                                    style={{ paddingBottom: '40px', width: "100%", height: 200, resize: "none", borderRadius: "3px" }}
                                />
                            </Form.Item>
                            <div style={{ position: 'absolute', right: 15, bottom: 10, zIndex: 10 }}>
                                <LgButton
                                    onClick={submit}
                                    backgroundType='opacification'
                                    type='info'
                                >
                                    发表
                                </LgButton>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
            <div className='messageList'>
                <div className='messageList_content'>
                    <div className="header">
                        <>
                            <div className="header_left">
                                <Select
                                    style={{ position: "relative", width: 101, height: 30 }}
                                    className="CommonSelect"
                                    // showSearch
                                    suffixIcon={<div className="selfSelectIcon"></div>}
                                    filterOption={(input: any, option: any) => {
                                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }}
                                    listHeight={226}
                                    disabled={typeList?.length > 0 ? false : true}
                                    value={type}
                                    onChange={setType}
                                >
                                    {
                                        typeList?.map(ele => {
                                            return <Select.Option value={ele.value} key={ele.value}>{ele.label}</Select.Option>
                                        })
                                    }
                                </Select>
                                <Select
                                    style={{ position: "relative", width: 101, height: 30 }}
                                    className="CommonSelect"
                                    suffixIcon={<div className="selfSelectIcon"></div>}
                                    listHeight={226}
                                    value={questionType}
                                    onChange={setQuestionType}
                                >
                                    <Select.Option value={0}>全部类型</Select.Option>
                                    <Select.Option value={1}>校园生活</Select.Option>
                                    <Select.Option value={2}>招生政策</Select.Option>
                                    <Select.Option value={3}>开学就业</Select.Option>
                                </Select>
                                <p className="plancounts">
                                    共
                                    <span style={{ color: "#333333" }}>{total}</span>
                                    条留言
                                </p>
                            </div>
                            <div className="header_right">
                                <div >
                                    <Search
                                        className="rsm_common_search"
                                        maxLength={20}
                                        placeholder="搜索提问内容..."
                                        value={keyword}
                                        onSearch={(value) => {
                                            setPageIndex(1);
                                            getInit({ keyword: value, pageIndex: 1 });
                                        }}
                                        onChange={(e) => setkeyword(() => e.target.value)}
                                        allowClear
                                        size="small"
                                    />
                                </div>
                            </div>
                        </>
                    </div>
                    <div className='content'>
                        <Spin spinning={isloading}>
                            {onceload ?
                                list?.length !== 0 ?
                                    list.map((ele: any, index: number) => {
                                        return <div key={ele.id || index} className='list'>
                                            <div className='list_head'>
                                                <div className="user-info1">
                                                    <img
                                                        src={ele.anonymity != "1" ? ele?.avatarImage || headerImg : headerImgHide}
                                                        width={28}
                                                        height={28}
                                                    />
                                                    <span className='name'>{ele?.anonymity == "1" ? "匿名" : (ele?.userName + (ele?.userId ? ('(' + ele.userId + ')') : ''))}</span>
                                                    <span className='time'>{ele?.createTime || ''}</span>
                                                    {ele.top === 1 && <div className='preblemTop'></div>}
                                                </div>
                                                <div className="user-info1" style={{ marginRight: 20, color: "#999999" }}>
                                                    <p>{ele.qType == 1 ? "校园生活" : ele.qType == 2 ? "招生政策" : "开学就业"}</p>
                                                </div>
                                            </div>

                                            <div className='list_problem'>
                                                <div>{ele?.msgContent || ''}</div>
                                            </div>
                                            <div className='list_reply'>
                                                {ele?.replyContent ? <div><span style={{ color: "#3333333", fontWeight: 700 }}>回复内容：</span>{ele?.replyContent}</div> : ''}
                                            </div>
                                            {ele?.enclosure && ele?.enclosure?.length > 0 &&
                                                <div style={{ marginLeft: 38 }}>
                                                    <ModuleCont title='附件' section={2}>
                                                        {ele?.enclosure.map((el: any) => {
                                                            return <FileDisplay
                                                                download={() => {
                                                                    downloadFile(el?.url || el?.preUrl, el?.originalName || el?.name)
                                                                }}
                                                                show={() => { previewFile(el) }}
                                                                key={el.md5Id || el.resId}
                                                                file={el.originalName}
                                                                panel
                                                            />
                                                        })}
                                                    </ModuleCont>
                                                </div>
                                            }
                                            {index !== (list.length - 1) && <div className='spit'></div>}
                                        </div>
                                    }) : <LabelNone search={keyword !== ""} />
                                : <div></div>
                            }
                            {total > pageSizeList[0].Info && <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20, paddingBottom: 6 }}>
                                <LgPaginationA
                                    total={Math.ceil(total / pageSize)}
                                    size="normal"
                                    currentPage={pageIndex}
                                    onChangePage={setPageIndex}
                                    pageSizeList={pageSizeList}
                                    pageSizeIndex={0}
                                    pageSizeSelect={pageSizeSelectA}
                                    pageSizePosition={"top"}
                                />
                            </div>}
                        </Spin>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnrollMessage
